import { useContext } from "react";
import { Cart, Check2Square, EnvelopeCheck, ExclamationOctagonFill } from "react-bootstrap-icons";
import { AuthContext } from "../../services/AuthContext";
import { GlobalFunctionsContext } from "../../services/GlobalFunctionsContext";

import "./OrderConfirmed.scss";
import { User } from "lucide-react";
import { usePage } from "../../services/PageContext";

export default function OrderConfirmed() {
  const { order } = useContext(AuthContext);
  const { formatNumber, formatCurrency } = useContext(GlobalFunctionsContext);
  const { isMobileStyle } = usePage()


  return (
    <>
    {order &&
    <div className="order-confirmed">
      <div className={`purple-header  confirmed ${isMobileStyle ? 'is-mobile' : ''}`}>
        <div className="congrats"></div>
        <div className='content'>
          <div className='title'>
            <Check2Square />
            Felicitaciones!</div>
          <div className='subtitle'>Su pedido se ha completado con éxito.<br /> <span>Su Número de Pedido es #{formatNumber(order.id)}</span> </div>
        </div>
        <div className="congrats congrats-right"></div>
      </div>
      <div className="cart-container">
        <div className="head-confirmation">
          <div className="message success">
            <EnvelopeCheck />
            Se ha enviado un correo de confirmación. Revise su correo no deseado.<br /> ¡Muchas gracias!
          </div>
          <div className="message warning">
            <ExclamationOctagonFill />
            Atención: no debe abonar nada hasta que el pedido sea confirmado por <br /> un representante.
          </div>
          <div className="data-content">
            <div className="blocks">
              <div className="title">
                <User />
                Mis datos
              </div>
              <div className="intern">
                <div className="intern-content">
                  <div className="title">Datos del pedido</div>
                  <div className="data">
                    <div className="data-item">Mi número de pedido: <b>#{formatNumber(order.id)}</b></div>
                    <div className="data-item">Fecha del pedido: <b>{order.fecha}</b></div>
                    {order.observaciones != 'undefined' &&
                      <div className="data-item">Observaciones: <b dangerouslySetInnerHTML={{ __html: order.observaciones }}></b></div>
                    }
                  </div>
                </div>

                <div className="intern-content">
                  <div className="title">Datos personales</div>
                  <div className="data">
                    <div className="data-item">Nombre: <b>{order.cliente}</b></div>
                    <div className="data-item">Email: <b>{order.email}</b></div>
                    <div className="data-item">Dirección: <b>{order.direccion_envio}</b></div>
                    <div className="data-item">Ciudad: <b> {order.ciudad}</b></div>
                    {order.transporte &&<div className="data-item">Transporte: <b>{order.transporte}</b></div>}
                  </div>
                </div>
              </div>
            </div>
            <div className="blocks">
              <div className="title">
                <Cart />
                Resumen de compra
              </div>
              <div className="intern">
                <div className="intern-content">
                  <div className="data">
                    <div className="data-item">Subtotal: <b>${formatCurrency(order.subtotal)}</b></div>
                    <div className="data-item">Descuento: <b>${formatCurrency(order.descuento)}</b></div>
                    <div className="data-item">IVA: <b>${formatCurrency(order.iva)}</b></div>
                  </div>
                </div>

                <div className="intern-content blue">
                  <div className="title">Total Estimativo <span>${formatCurrency(order.total)}</span></div>
                  <div className="data">
                    <div className="note">* Los precios y el stock pueden variar sin previo aviso y están sujetos a cambios inflacionarios.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  </>
  )
}